import { Button, Col, ListGroup, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../../services/PrivateApiService";
import EmployeeListItem from "./EmployeeListItem";
import { useQuery } from "react-query";
import { useState } from "react";
import AddTeamModal from "./AddTeamModal";

const TeamView = () => {

    const API = new PrivateApi();
    const [addModal, setAddModal] = useState(false);
    const [openedId, setOpenedId] = useState(0);
    const {data, error, isLoading} = useQuery("GET_EMPLOYEES", API.get_Partner_employees, {staleTime: Infinity});

    if (isLoading) return <><Spinner animation="border" className="text-energo" style={{marginRight: 5}} /><span>Daten werden gesammelt...</span></>
    if (error) return <p className="text-danger">Fehler passiert. Versuchen Sie später.</p>

    return (
        <>
            <Row className="align-items-center">
                <Col xs="12" xl="8">
                    <h5>Kontaktpersonen</h5>
                    <p className="text-muted">Hier können Sie die Kontaktpersonen Ihres Unternehmens anpassen</p>
                </Col>
                <Col xs="12" xl="4" className="text-center">
                    <Button onClick={() => setAddModal(true)} className="btn-sm btn-energo">Kontakt hinzufügen</Button>
                </Col>
            </Row>
            <hr />
            <Row >
                <Col>
                    <Row style={{marginLeft: 5, marginRight: 5}}>
                        <Col xs="3"><b>Name</b></Col>
                        <Col xs="5"><b>E-Mail-Adresse</b></Col>
                        <Col xs="3"><b>Telefonnummer</b></Col>
                        <Col xs="1"></Col>
                    </Row>
                    <ListGroup className="list-group-flush">
                        {data.data.map(emp => (
                            <EmployeeListItem key={emp.id} employee={emp} openId={openedId} setOpenId={setOpenedId} />
                        ))}
                    </ListGroup>
                </Col>
            </Row>
            <AddTeamModal open={addModal} setOpen={setAddModal} />
        </>
    )
}
export default TeamView;